import React from 'react'
import styled from 'styled-components'
import {
  Box,
  ButtonUnstyled,
  LoadingSpinner,
  ScreenReaderText,
} from '@allied-solutions/affinity'

import { useCiamAuthorize } from '../hooks'

export const CIAM_AUTHORIZE_LINK_HREF = '#create-account'

const AuthorizeButton = styled(ButtonUnstyled)`
  text-decoration: underline;

  &:focus {
    outline: none;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &:focus-visible {
    outline: 3px solid ${props => props.theme.colors.blue600};
    z-index: 11;
    outline-offset: 3px;
    border-radius: 5px;
  }
`

export const CiamAuthorizeLink = ({ children, ...props }) => {
  const { handleAuthorize, isAuthorizing } = useCiamAuthorize()

  return (
    <>
      <AuthorizeButton
        typeStyle="bodyLarge"
        color="text.link"
        onClick={() => handleAuthorize()}
        disabled={isAuthorizing}
        {...props}
      >
        {children}
      </AuthorizeButton>
      {isAuthorizing ? (
        <Box as="span" display="inline-flex" alignItems="center">
          <LoadingSpinner size="sm" aria-hidden />
          <ScreenReaderText>Logging in…</ScreenReaderText>
        </Box>
      ) : null}
    </>
  )
}
